import * as types from '../actions/types';

const initialState = {
    page: 1,
    success: false
}

export default function AnnouncementPageReducer(state = initialState, action = undefined) {
    switch (action.type) {
        case types.ANNOUNCEMENT_FAQ:
            return {
                page: action.payload,
                success: true
            }
        default:
            return state
    }
}